import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

import { RoutePath } from '@shared/enums/route-path.enum';
import { AuthGuard } from '@shared/guards/auth.guard';
import { ResidentGuard } from '@shared/guards/resident.guard';

import { MainApplicationComponent } from './main-application.component';

const routes: Routes = [
  {
    path: '',
    component: MainApplicationComponent,
    children: [
      {
        path: RoutePath.RESIDENT,
        canActivate: [AutoLoginPartialRoutesGuard, AuthGuard],
        loadChildren: () => import('@main-application/resident/resident.module').then(m => m.ResidentModule),
      },
      {
        path: '',
        canActivate: [ResidentGuard],
        loadChildren: () =>
          import('@main-application/application-menu/application-menu.module').then(m => m.ApplicationMenuModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainApplicationRoutingModule {}
